module.exports = __webpack_public_path__ + "static/media/shuttleExperienceIcon.6eb65850.png";